import { render, staticRenderFns } from "./billReq.vue?vue&type=template&id=10700212&scoped=true"
import script from "./billReq.vue?vue&type=script&lang=js"
export * from "./billReq.vue?vue&type=script&lang=js"
import style0 from "./billReq.vue?vue&type=style&index=0&id=10700212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10700212",
  null
  
)

export default component.exports